import { AlertTriangle, FileDown, Loader2 } from "lucide-react";

const ExportButton = ({selected,isBusy,isRecentlyPerformed,startBackup,phase}) => {
  return (
    <button
      type="button"
      disabled={selected.length === 0 || isBusy || isRecentlyPerformed}
      onClick={startBackup}
      className="flex w-full items-center justify-center gap-2.5 rounded-2xl bg-[#1B2740] px-[18px] py-4 text-[14.5px] font-bold text-[#F3EEE2]
                shadow-[0_6px_0_#0C1422] transition-transform active:translate-y-0.5 active:shadow-[0_2px_0_#0C1422]
                disabled:cursor-not-allowed disabled:opacity-50 disabled:shadow-none
                focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#B8862B]"
    >
      {isRecentlyPerformed ? (
        <>
          <AlertTriangle size={18} />
          زمان مجاز برای پشتیبان‌گیری بعدی نرسیده است!
        </>
      ) : phase === "generating" || phase === "downloading" ? (
        <>
          <Loader2 size={18} className="animate-spin" />
          {phase === "generating"
            ? "در حال ساخت فایل پشتیبان…"
            : "در حال آماده‌سازی دانلود…"}
        </>
      ) : (
        <>
          <FileDown size={18} />
          تولید فایل پشتیبان (Excel)
        </>
      )}
    </button>
  );
};

export default ExportButton;
